import { createContext } from 'react';
import { IItemForGetShortInfoWithStatus, TPropertiesOfPatchChangesForModifiers } from 'types';

export type TTypeOfModalWindow = Nullable<'toConfirmFieldsClearing' | 'error'>;

export interface ISaveAsPatchState {
	initialFormData: {
		modifierId: string;
		customerName: string;
		fetchedRestaurants: IItemForGetShortInfoWithStatus[];
		IDSelectedRestaurantOnRestPropsPage: Nullable<string>;
		price: Nullable<number>;
		supplementPrice: Nullable<number>;
		quantityMaxLimit: Nullable<number>;
		activationSchedule: string;
		deactivationSchedule: string;
		hasSchedulePriority: boolean;
		inStop: boolean;
		isRestricted: boolean;
		isPreselected: boolean;
		forceDisable: boolean;
		isCreatedFromPos: boolean;
		hasPortions: boolean;
	};
	typeOfChanges: 'basedChanges' | 'independentChanges';
	IDsSelectedRestaurant: string[];
	price: Nullable<number>;
	supplementPrice: Nullable<number>;
	quantityMaxLimit: Nullable<number>;
	activationSchedule: string;
	deactivationSchedule: string;
	inStop: boolean;
	isRestricted: boolean;
	isPreselected: boolean;
	forceDisable: boolean;
	isCreatedFromPos: boolean;
	selectedProperties: TPropertiesOfPatchChangesForModifiers[];
	typeOfModalWindow: TTypeOfModalWindow;
}

export const saveAsPatchInitialState: ISaveAsPatchState = {
	initialFormData: {
		modifierId: '',
		customerName: '',
		fetchedRestaurants: [],
		IDSelectedRestaurantOnRestPropsPage: null,
		price: null,
		supplementPrice: null,
		quantityMaxLimit: null,
		activationSchedule: '',
		deactivationSchedule: '',
		hasSchedulePriority: false,
		inStop: false,
		isRestricted: false,
		isPreselected: false,
		forceDisable: false,
		isCreatedFromPos: false,
		hasPortions: false,
	},
	typeOfChanges: 'basedChanges',
	IDsSelectedRestaurant: [],
	price: null,
	supplementPrice: null,
	quantityMaxLimit: null,
	activationSchedule: '',
	deactivationSchedule: '',
	inStop: false,
	isRestricted: false,
	isPreselected: false,
	forceDisable: false,
	isCreatedFromPos: false,
	selectedProperties: [],
	typeOfModalWindow: null,
};

export interface ISaveAsPatchContext extends ISaveAsPatchState {
	saveData(value: 'saveAndMakeOtherChanges' | 'saveAndClose'): void;
	setTypeOfChanges(value: ISaveAsPatchState['typeOfChanges']): void;
	setIDsRestaurant(value: ISaveAsPatchState['IDsSelectedRestaurant']): void;
	setProperties: (value: ISaveAsPatchState['selectedProperties']) => void;
	changePrice(value: ISaveAsPatchState['price']): void;
	changeSupplementPrice(value: ISaveAsPatchState['supplementPrice']): void;
	changeQuantityMaxLimit(value: ISaveAsPatchState['quantityMaxLimit']): void;
	changeActivationSchedule(value: ISaveAsPatchState['activationSchedule']): void;
	changeDeactivationSchedule(value: ISaveAsPatchState['deactivationSchedule']): void;
	toggleInStop(): void;
	toggleIsRestricted(): void;
	toggleIsPreselected(): void;
	toggleForceDisable(): void;
	changeTypeOfModalWindow(value: ISaveAsPatchState['typeOfModalWindow']): void;
}

export const SaveAsPatchContext = createContext<ISaveAsPatchContext>({
	saveData: () => undefined,
	setTypeOfChanges: () => undefined,
	setIDsRestaurant: () => undefined,
	setProperties: () => undefined,
	changePrice: () => undefined,
	changeSupplementPrice: () => undefined,
	changeQuantityMaxLimit: () => undefined,
	changeActivationSchedule: () => undefined,
	changeDeactivationSchedule: () => undefined,
	toggleInStop: () => undefined,
	toggleIsRestricted: () => undefined,
	toggleIsPreselected: () => undefined,
	toggleForceDisable: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...saveAsPatchInitialState,
});
